(function () {
  Controller.$inject = ['SensorService', 'AppUtils', '$interval'];

  const angular = window.angular;
  const $ = window.$;
  angular.module('app').component('videoDisplay', {
    template:'<div class="panel panel-default rt-panel rt-panel-sm" ng-if="!ctrl.onlyContent"><header class="panel-heading"><h2 class="nowrap"><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="ctrl.video" data-html2canvas-ignore><div class="panel-toolbar"><div class="btn-group" data-toggle="buttons"><label ng-click="ctrl.viewMode = \'video\'" ng-class="{active: ctrl.viewMode === \'video\'}" class="btn btn-default btn-xs" title="Video"><input type="radio"> <i class="fas fa-video"></i></label> <label ng-click="ctrl.viewMode = \'raw\'" ng-class="{active: ctrl.viewMode === \'raw\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.details\'}"><input type="radio"> <i class="fas fa-code"></i></label></div></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location, \'with-chart\': ctrl.activity.variation.length}"><div class="rt-content"><div ng-if="ctrl.viewMode===\'video\'"><video-renderer video-src="ctrl.videoSrc" on-load="ctrl.onLoad"></video-renderer><video-activity-chart ng-if="ctrl.activity.variation.length" variation="ctrl.activity.variation" min="ctrl.activity.min" max="ctrl.activity.max" avg="ctrl.activity.avg" stddev="ctrl.activity.stddev" date="ctrl.data.from" video-element="ctrl.video"></video-activity-chart></div><pre ng-if="ctrl.viewMode=== \'raw\'">{{ctrl.content | json}}</pre></div><div class="rt-footer"><div class="date" ng-if="ctrl.data.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div><div class="rt-footer chart-footer" ng-if="ctrl.data && !ctrl.data.content"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="rt-footer chart-footer" ng-if="!ctrl.data"><div class="small"><i translate>general.loading</i><i>...</i></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content" style="top: 0; bottom: 0; right: 0; left: 0"><div ng-if="ctrl.viewMode===\'video\'"><video-renderer video-src="ctrl.videoSrc" on-load="ctrl.onLoad"></video-renderer><vide-activity-chart ng-if="ctrl.activity.variation.length" variation="ctrl.activity.variation" min="ctrl.activity.min" max="ctrl.activity.max" avg="ctrl.activity.avg" stddev="ctrl.activity.stddev" date="ctrl.data.from" video-element="ctrl.video"></vide-activity-chart></div><pre ng-if="ctrl.viewMode=== \'raw\'">{{ctrl.content | json}}</pre><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      assetName: '<',
      data: '<',
      onlyContent: '<',
      onLoadContent: '<',
    },
  });

  function Controller(SensorService, utils, $interval) {
    const vm = this;
    vm.$onInit = () => {};

    vm.$onChanges = (changes) => {
      if (changes.data && vm.data) {
        const video = vm.data.content?.files?.video?.[0];

        vm.viewMode = 'raw';
        if (video) {
          vm.videoSrc = SensorService.getFileUrl(vm.sensor.id, video);
          vm.viewMode = 'video';
        }

        vm.content = vm.data.content;

        vm.activity = vm.data.content.activity || {};
      }

      vm.onLoad = onLoad;
    };

    function onLoad(err, video) {
      if (err) {
        vm.viewMode = 'raw';
      }
      vm.video = video;
      if (vm.onLoadContent) {
        vm.onLoadContent(err, video);
      }
    }
  }
})();
